var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.resource)?_c('div',{class:_vm.$style.background},[_c('BaseResourceImage',{class:_vm.$style.image,style:(`filter: ${_vm.isGreyscaled ? 'grayscale(100%)' : ''} ${_vm.isBlurred ? 'blur(9px)' : ''};`),attrs:{"resource":_vm.resource,"type":_vm.type,"should-lazyload":false,"is-background":true,"fill":false}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }